module.exports = __webpack_public_path__ + "static/media/21(2).fb44174d.jpg";